var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistoryTimerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4606",
    "data-name": "Group 4606",
    transform: "translate(-1424 -1240)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "history-timer-icon",
    transform: "translate(1424 1240)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1234",
    "data-name": "Rectangle 1234",
    width: 12,
    height: 12,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3569",
    "data-name": "Group 3569"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_197",
    "data-name": "Ellipse 197",
    fill: "none",
    stroke: "#a06b16",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3568",
    "data-name": "Group 3568",
    transform: "translate(6 4.022)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_171",
    "data-name": "Line 171",
    y2: 2.199,
    transform: "translate(0)",
    fill: "none",
    stroke: "#a06b16",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_172",
    "data-name": "Line 172",
    y2: 2.199,
    transform: "matrix(-0.799, 0.602, -0.602, -0.799, 1.324, 3.955)",
    fill: "none",
    stroke: "#a06b16",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryTimerIcon);
export default __webpack_public_path__ + "static/media/history-timer-icon.fc0c1dc884e3f4c355ac1af4d44cff23.svg";
export { ForwardRef as ReactComponent };